var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.meta && _vm.meta.h1)?_c('h1',[_vm._v(_vm._s(_vm.meta.h1))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }